import { connect } from 'react-redux';
import ViolationComment from './ViolationComment';
import { addViolationCommentBegin } from '../../../../store/actions/violation.actions';
import { getAddViolationCommentLoader, getViolationCommentList } from '../../../../store/selectors/violation.selectors';
const mapStateToProps = (state: any) => {
    const loading = getAddViolationCommentLoader(state);
    const violationCommentList = getViolationCommentList(state);

    return {
        loading,
        violationCommentList,
    };
};

const mapDispatchToProps = {
    addViolationComment: addViolationCommentBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViolationComment);
